/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PhoneNumberBody,
    PhoneNumberBodyFromJSON,
    PhoneNumberBodyFromJSONTyped,
    PhoneNumberBodyToJSON,
} from './';

/**
 * 
 * @export
 * @interface GetOnboardingInformationResponse
 */
export interface GetOnboardingInformationResponse {
    /**
     * 
     * @type {string}
     * @memberof GetOnboardingInformationResponse
     */
    signedUrlKey: string;
    /**
     * 
     * @type {string}
     * @memberof GetOnboardingInformationResponse
     */
    email?: string;
    /**
     * 
     * @type {PhoneNumberBody}
     * @memberof GetOnboardingInformationResponse
     */
    phoneNumber?: PhoneNumberBody;
    /**
     * 
     * @type {string}
     * @memberof GetOnboardingInformationResponse
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof GetOnboardingInformationResponse
     */
    lastName?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetOnboardingInformationResponse
     */
    wallets?: Array<string>;
}

export function GetOnboardingInformationResponseFromJSON(json: any): GetOnboardingInformationResponse {
    return GetOnboardingInformationResponseFromJSONTyped(json, false);
}

export function GetOnboardingInformationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetOnboardingInformationResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'signedUrlKey': json['signedUrlKey'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'phoneNumber': !exists(json, 'phoneNumber') ? undefined : PhoneNumberBodyFromJSON(json['phoneNumber']),
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'wallets': !exists(json, 'wallets') ? undefined : json['wallets'],
    };
}

export function GetOnboardingInformationResponseToJSON(value?: GetOnboardingInformationResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'signedUrlKey': value.signedUrlKey,
        'email': value.email,
        'phoneNumber': PhoneNumberBodyToJSON(value.phoneNumber),
        'firstName': value.firstName,
        'lastName': value.lastName,
        'wallets': value.wallets,
    };
}


